import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';

import WixSDK from 'shared/utils/wix-sdk';
import { REFRESH_EVENT, storeForReload } from 'widget/utils/reload';


const compId = WixSDK.Utils.getCompId();


// TODO: enhance this to look like real storage with get/set/remove methods

/*
 * Since after UOU login or logout, whole site rebuilds, and there is no nice solution in WixSDK for this case.
 * This is workaround, that use persistent events in Wix.PubSub. Anytime we let user login or logout, we also
 * stores data, that we want to path into "next state" of widget after it's reloaded. But since we use
 * persistent events, they are stored in same sequence as we publish them until site is closed or manually refreshed.
 * But we need only last one, that's why we use @debounce for method `processRetrievedData`
 */
export default class ReloadStorage extends React.Component {

  static propTypes = {
    onReload: React.PropTypes.func,
  };

  static defaultProps = {
    onReload: _.noop,
  };

  componentDidMount() {
    this.subscribeId = WixSDK.PubSub.subscribe(
      REFRESH_EVENT,
      this.retrieveDataAfterReload,
      true,
    );
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  unsubscribe() {

    WixSDK.PubSub.unsubscribe(this.subscribeId);
    storeForReload(null);
  }

  @autobind
  @debounce
  retrieveDataAfterReload({ data, origin }) {
    const { onReload } = this.props;
    const { stored } = data;

    if (origin === compId && stored) {
      onReload(stored);

      this.unsubscribe();
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/reload-storage/reload-storage.js